import { render, staticRenderFns } from "./EditConsignment.vue?vue&type=template&id=4bc08bf9"
import script from "./EditConsignment.vue?vue&type=script&lang=js"
export * from "./EditConsignment.vue?vue&type=script&lang=js"
import style0 from "./EditConsignment.vue?vue&type=style&index=0&id=4bc08bf9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports